import { toast, ToastOptions } from 'react-toastify'

import type { AlertPresenter } from './alertTypes'

export const throttleError = 'throttleError'
export const closeStripeError = 'closeStripeError'

const readableError = (err: string) => err.split(' (')[0]?.replace('Firebase: ', '')

export const showError = (err?: any) => {
  const toastOptions: ToastOptions = { type: 'error', position: 'bottom-center' }
  if (err?.response?.data?.message) {
    toast(err.response.data.message, toastOptions)
  } else if (err?.message) {
    if (err.message !== closeStripeError && err.message !== throttleError) {
      toast(readableError(err.message), toastOptions)
    }
  } else if (err) {
    toast(err, toastOptions)
  } else {
    toast('Something went wrong!', toastOptions)
  }
}

export const showSuccess = (message: string) => {
  const toastOptions: ToastOptions = { type: 'success', position: 'bottom-center' }
  toast(message, toastOptions)
}

export const showAlert: AlertPresenter = (title, primaryButton, message, secondaryButton) =>
  new Promise<boolean>(resolve =>
    toast(
      ({ closeToast }) => (
        <div style={{ width: '100%' }}>
          <h4>{title}</h4>
          {message && <p>{message}</p>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <button onClick={() => closeToast(false)} style={{ cursor: 'pointer' }}>
              {primaryButton}
            </button>
            {secondaryButton && (
              <button onClick={() => closeToast(true)} style={{ cursor: 'pointer' }}>
                {secondaryButton}
              </button>
            )}
          </div>
        </div>
      ),
      {
        position: 'bottom-center',
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        onClose: reason => resolve(!reason),
      }
    )
  )

export const showConfirm = (title: string) => showAlert(title, 'Yes', undefined, 'No')
